import Modal from 'LuxKit/Modal/Modal'
import React, { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import ChatsHistoryList from './ChatsHistoryList'
import type { NewChatModalResult } from '../Chat/NewChatModal'
import NewChatModal from '../Chat/NewChatModal'
import ModalContext from 'contexts/ModalContext'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { createNewChat } from 'actions/supportAssistant/supportAssistantActions'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'

export interface ChatHistoryModalResult {
  chatId: string | undefined
}

function ChatsHistoryModal() {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const customerId = useAppSelector(state => state.auth.account.memberId)
  const currentChatId = useAppSelector(state => state.supportAssistant.currentChatId)

  const showModal = useContext(ModalContext)

  const modalElement = useModalElementContext<ChatHistoryModalResult>()

  const handleNewChatClick = useCallback(async() => {
    if (!customerId && currentChatId) {
      const result = await showModal<NewChatModalResult>(<NewChatModal />)
      if (result?.triggerLogin) {
        showModal(<AccountAccessModal initialMode="supportLogin" />)
      }
      modalElement.resolve({ chatId: undefined })
    } else {
      dispatch(createNewChat())
      modalElement.resolve({ chatId: undefined })
    }
  }, [currentChatId, customerId, dispatch, modalElement, showModal])

  const handleSelectChatClick = useCallback((chatId: string) => {
    modalElement.resolve({ chatId })
  }, [modalElement])

  return (
    <Modal
      title={intl.formatMessage({
        id: 'RiHhUg+m1w',
        defaultMessage: 'Chat History',
        description: 'Title for chat history modal',
      })}
      mode="menu"
      height="full"
      primaryActionText={intl.formatMessage({
        id: 'v2I391FGl0',
        defaultMessage: 'New Chat',
        description: 'Button text to start a new chat from history modal',
      })}
      onPrimaryActionClick={handleNewChatClick}
    >
      <ChatsHistoryList onChatSelect={handleSelectChatClick} />
    </Modal>
  )
}

export default ChatsHistoryModal
